import { httpClient } from "../../lib/http-client";
import { IInvitedUser } from "../../views/settings/platform/platform.interface";

const blockUnblockUserApi = async (rowData: { objectid: string }, isActive: boolean) => {
  const action = isActive ? "unblock" : "block";
  const response = await httpClient.put(`/api/v1/admin/users/${rowData.objectid}/${action}`);
  return response.data;
};

export const getUsersApi = async () => {
  const response = await httpClient.get("/api/v1/admin/users");
  return response.data;
};

const getUserForSearchApi = async (search: string) => {
  const response = await httpClient.get(`/api/v1/admin/users/search?q=${search}`);
  return response.data;
};

const IsUserAddedApi = async (payload: { email: string }) => {
  const response = await httpClient.post("/api/v1/admin/users/check", payload);
  return response.data;
};

const createUserApi = async (userModel: Record<string, unknown>) => {
  const response = await httpClient.post("/api/v1/admin/users", userModel);
  return response.data;
};

const deleteUsersApi = async (userObjectIds: string[]) => {
  // Delete each user individually
  const results = [];
  for (const id of userObjectIds) {
    const response = await httpClient.delete(`/api/v1/admin/users/${id}`);
    results.push(response.data);
  }
  return results.length === 1 ? results[0] : results;
};

// Stubbed SPC-only functions — not supported locally

const getInvitedUsersApi = async (
  _pageNumber: number,
  _filter: string,
  _sortBy: string,
  _sortOrder: string,
): Promise<IInvitedUser[]> => {
  return [] as IInvitedUser[];
};

const getInvitedUserCountApi = async (
  _pageNumber: number,
  _filter: string,
  _sortBy: string,
  _sortOrder: string,
) => {
  return { isError: false, result: 0 } as { isError: boolean; result: number };
};

const getRolesApi = async () => {
  return { roles: [], isTenantAdmin: false };
};

const addUserToInstanceApi = async (_addUserModel: object) => {
  return { isSuccess: false, message: "Not supported locally" };
};

const inviteUsersApi = async (_model: object) => {
  return { isSuccess: false, message: "Not supported locally" };
};

const unlinkUserRoleApi = async (_userObjectIds: string[]) => {
  return { isSuccess: false, message: "Not supported locally" };
};

const reInviteUserApi = async (_inviteUser: IInvitedUser) => {
  return { isSuccessful: false, message: "Not supported locally" };
};

const addDomainWhitelistApi = async (_domainData: { domain: string; name: string }) => {
  return {
    isError: true,
    message: "Not supported locally",
    responseException: { exceptionMessage: "Not supported locally" },
  };
};

const getDomainListApi = async () => {
  return {
    isError: false,
    result: { domainMappingList: [] as string[] },
    message: "",
  };
};

const deleteDomainsApi = async (_domainIds: string[]) => {
  return {
    isError: true,
    result: { isSuccessful: false, message: "Not supported locally" },
    message: "Not supported locally",
  };
};
